export const filterOperators = {
  string: ["equals", "not equals", "contains", "does not contain"],
  number: ["equals", "not equals", "greater than", "less than"],
  boolean: ["true", "false"],
  date: ["before", "after", "between"],
  "multi-select": ["includes", "excludes"],
  "creatable-multi-select": ["includes", "excludes"],
  "creatable-select": ["includes", "excludes"],
};
